<template>
    <div class="layout-side-pannel">
        <header class="header">
            <slot name="header"></slot>
        </header>
        <aside class="aside">
            <slot name="aside"></slot>
        </aside>
        <main class="main">
            <slot name="main"></slot>
        </main>
    </div>
</template>

<style lang="scss">
.layout-side-pannel {
    display: grid;
    grid-template-areas:
        'header header'
        'aside main';
    grid-template-columns: 350px 1fr;
    grid-template-rows: 40px 1fr;
    gap: 24px;

    @media (max-width: 1200px) {
        grid-template-areas:
            'header header'
            'main main'
            'aside aside';
        grid-template-rows: 40px auto 1fr;
    }

    header {
        grid-area: header;
        padding: 0 12px;
    }

    aside {
        grid-area: aside;
        background-color: var(--color-white);
        border-radius: 4px;
        padding: 32px 24px;
        height: max-content;
    }

    main {
        grid-area: main;
        background-color: var(--color-white);
        border-radius: 4px;
        padding: 32px 24px;
        overflow: auto;
        height: max-content;
    }
}
</style>
